import FakeInput from "@edaz/edazkit/controls/FakeInput";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import { formatAmount, formatDateTime, formatLicensePlate } from "utils/localizations";
import type CustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/customerRefundCandidates/customerRefundCandidateDetailViewModel";
import type RejectedCustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidateDetailViewModel";
import Section from "views/common/section";

const OrderSection: ViewComponent<CustomerRefundCandidateDetailViewModel | RejectedCustomerRefundCandidateDetailViewModel> =
  observer(({ vm }) => {
    const charge = vm.item.charge;

    return (
      <Section title={vm.translate("order")} context={charge}>
        <Form.Row>
          <Form.Group as={Col} sm={6} md={4} lg={3} xl={2}>
            <Form.Label>{vm.translateSubAttribute("charge", "vehicle")}</Form.Label>
            <FakeInput target={charge} property="vehicle" valueFormatter={formatLicensePlate} />
          </Form.Group>
          <Form.Group as={Col} sm={6} md={4} lg={3} xl={2}>
            <Form.Label>{vm.translateSubAttribute("charge", "chargeTypeId")}</Form.Label>
            <FakeInput target={charge} property="priceListItemId" valueFormatter={value => vm.translateChargeType(value)} />
          </Form.Group>
          <Form.Group as={Col} sm={6} md={4} lg={3} xl={2}>
            <Form.Label>{vm.translateSubAttribute("charge", "fuelTypeId")}</Form.Label>
            <FakeInput target={charge} property="priceListItemId" valueFormatter={value => vm.translateFuelType(value)} />
          </Form.Group>
          <Form.Group as={Col} sm={6} md={4} lg={3} xl={2}>
            <Form.Label>{vm.translateSubAttribute("charge", "price")}</Form.Label>
            <FakeInput target={charge} property="price" valueFormatter={formatAmount} />
          </Form.Group>
          <Form.Group as={Col} sm={6} md={4} lg={3} xl={2}>
            <Form.Label>{vm.translateSubAttribute("charge", "validSince")}</Form.Label>
            <FakeInput target={charge} property="validSince" valueFormatter={formatDateTime} />
          </Form.Group>
          <Form.Group as={Col} sm={6} md={4} lg={3} xl={2}>
            <Form.Label>{vm.translateSubAttribute("charge", "validUntil")}</Form.Label>
            <FakeInput target={charge} property="validUntil" valueFormatter={formatDateTime} />
          </Form.Group>
          <Form.Group as={Col} sm={6} md={4} lg={3} xl={4}>
            <Form.Label>{vm.translateSubAttribute("customerRefundCandidate", "variableSymbol")}</Form.Label>
            <FakeInput target={vm.item} property="variableSymbol" />
          </Form.Group>
          <Form.Group as={Col} sm={6} md={4} lg={3} xl={4}>
            <Form.Label>{vm.translateSubAttribute("charge", "orderId")}</Form.Label>
            <FakeInput target={charge} property="chargeOrderId" />
          </Form.Group>
        </Form.Row>
      </Section>
    );
  });

export default OrderSection;
